import classnames from 'classnames';
import React from 'react';

import { TemplateImage } from '../../modules/templateImages';

import './placeholderImage.scss';

interface Props {
  image: TemplateImage;
  sizes: string;
}

interface State {
  loaded: boolean;
}

export class PlaceholderImage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { loaded: false };
    this.imageLoaded = this.imageLoaded.bind(this);
  }

  public render(): JSX.Element {
    const { small, medium, large, placeholder } = this.props.image;
    return (
      <div
        className={classnames('placeholder-image-component', {
          'placeholder-image-component__loaded': this.state.loaded,
        })}
      >
        <div className="placeholder-image-component__image-wrapper">
          <img
            className={classnames(
              'placeholder-image-component__image',
              'placeholder-image-component__placeholder'
            )}
            src={placeholder}
            alt=""
          />
          <img
            className={classnames(
              'placeholder-image-component__image',
              'placeholder-image-component__fullsize'
            )}
            srcSet={`${small} 330w, ${medium}  480w, ${large} 630w`}
            src={large}
            onLoad={this.imageLoaded}
            sizes={this.props.sizes}
            alt=""
          />
        </div>
      </div>
    );
  }

  private imageLoaded(): void {
    this.setState({ loaded: true });
  }
}
